import React from 'react';
import ListenPart1 from '../exercises/ListenPart1';
import ListenPart2 from '../exercises/ListenPart2';
import ListenPart3 from '../exercises/ListenPart3';
import ListenPart4 from '../exercises/ListenPart4';
import ListenPart5 from '../exercises/ListenPart5';
import ReadingPart1 from '../exercises/ReadingPart1';
import ReadingPart2 from '../exercises/ReadingPart2';
import ReadingPart3 from '../exercises/ReadingPart3';
import ReadingPart4 from '../exercises/ReadingPart4';
import ReadingPart5 from '../exercises/ReadingPart5';
import ReadingPart6 from '../exercises/ReadingPart6';
import ReadingPart7 from '../exercises/ReadingPart7';

const exerciseComponentMap = {
  'listen_flyer_part_1': ListenPart1,
  'listen_flyer_part_2': ListenPart2,
  'listen_flyer_part_3': ListenPart3, // Add mapping for ListenPart3
  'listen_flyer_part_4': ListenPart4, // Add mapping for ListenPart4
  'listen_flyer_part_5': ListenPart5, // Add mapping for ListenPart5
  'reading_writing_flyer_part_1': ReadingPart1, // Correct the key for ReadingPart1
  'reading_writing_flyer_part_2': ReadingPart2, // Add mapping for ReadingPart2
  'reading_writing_flyer_part_3': ReadingPart3, // Add mapping for ReadingPart3
  'reading_writing_flyer_part_4': ReadingPart4, // Add mapping for ReadingPart4
  'reading_writing_flyer_part_5': ReadingPart5, // Add mapping for ReadingPart5
  'reading_writing_flyer_part_6': ReadingPart6, // Add mapping for ReadingPart6
  'reading_writing_flyer_part_7': ReadingPart7, // Add mapping for ReadingPart7
};

const FocusedExerciseView = ({ exercise, attemptId, isReviewMode, showHint, fillHintSignal, zoomLevel, sharedColor, setSharedColor }) => {
  if (!exercise) {
    return <p>Loading exercise...</p>;
  }

  const ExerciseComponent = exerciseComponentMap[exercise.type];

  if (!ExerciseComponent) {
    return (
      <div>
        <div className="error-message">Error: Unsupported exercise type "{exercise.type}"</div>
        <pre>{JSON.stringify(exercise, null, 2)}</pre>
      </div>
    );
  }

  return (
    <div className="w-full flex-1 flex flex-col min-h-0">
      <ExerciseComponent
        exerciseData={exercise}
        attemptId={attemptId}
        exerciseId={exercise.id}
        isReviewMode={isReviewMode}
        showHint={showHint}
        fillHintSignal={fillHintSignal}
        zoomLevel={zoomLevel}
        sharedColor={sharedColor}
        setSharedColor={setSharedColor}
      />
    </div>
  );
};

export default FocusedExerciseView;
